<div class="sd-container sd-container--variant-white">
  <div class="sd-headline sd-headline--size-3xl">{{ 'profile.recertification.headline' | transloco }}</div>
  <p>{{ 'profile.recertification.description' | transloco }}</p>

  <section class="recertification-manage-access">
    <sd-4-5-1-button
      (click)="createUser()"
      size="md"
      variant="cta">
      {{ 'profile.manageAccesses.createUser' | transloco }}
    </sd-4-5-1-button>
    <sd-4-5-1-button
      (click)="recertificate()"
      size="md"
      variant="cta">
      {{ 'profile.manageAccesses.recertifications' | transloco }}
    </sd-4-5-1-button>
  </section>

  <section class="recertification-colleagues" [wctApiCallInject]="colleagues">
    @for (colleague of colleagues(); track $index) {
      <wct-colleague-display [colleague]="colleague" [editable]="!colleague.userInfo.pending">
        @if (colleague.userInfo.pending) {
          <wct-user-pending-label label />
        }
      </wct-colleague-display>
    } @empty {
      <div style="height: 240px;"></div>
    }
  </section>
</div>
